import { Feld, FeldHuelle, grundGroesse, type FeldEigenschaften, type FeldGroesseGrund } from "./feld";

/** Mehrzeiliges Eingabefeld (Preline `textarea-label`); Größe × Fehlerzustand als feste Klassenketten. */
type MehrzeilerRest = Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, "id" | "className" | "style" | "children">;

const KLASSEN: Record<FeldGroesseGrund, { normal: string; fehler: string }> = {
  standard: {
    normal:
      "py-2 px-3 sm:py-3 sm:px-4 block w-full bg-layer border-layer-line rounded-lg sm:text-sm text-foreground placeholder:text-muted-foreground-1 focus:border-primary-focus focus:ring-primary-focus disabled:opacity-50 disabled:pointer-events-none [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-none [&::-webkit-scrollbar-track]:bg-scrollbar-track [&::-webkit-scrollbar-thumb]:bg-scrollbar-thumb",
    fehler:
      "py-2 ps-3 pe-10 sm:py-3 sm:ps-4 block w-full bg-layer border-red-500 rounded-lg sm:text-sm text-foreground placeholder:text-muted-foreground-1 focus:border-red-500 focus:ring-red-500 disabled:opacity-50 disabled:pointer-events-none [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-none [&::-webkit-scrollbar-track]:bg-scrollbar-track [&::-webkit-scrollbar-thumb]:bg-scrollbar-thumb",
  },
  kompakt: {
    normal:
      "py-1.5 px-3 sm:py-2 block w-full bg-layer border-layer-line rounded-lg sm:text-sm text-foreground placeholder:text-muted-foreground-1 focus:border-primary-focus focus:ring-primary-focus disabled:opacity-50 disabled:pointer-events-none [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-none [&::-webkit-scrollbar-track]:bg-scrollbar-track [&::-webkit-scrollbar-thumb]:bg-scrollbar-thumb",
    fehler:
      "py-1.5 ps-3 pe-10 sm:py-2 block w-full bg-layer border-red-500 rounded-lg sm:text-sm text-foreground placeholder:text-muted-foreground-1 focus:border-red-500 focus:ring-red-500 disabled:opacity-50 disabled:pointer-events-none [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-none [&::-webkit-scrollbar-track]:bg-scrollbar-track [&::-webkit-scrollbar-thumb]:bg-scrollbar-thumb",
  },
};

export function Mehrzeiler({
  id,
  label,
  labelVersteckt,
  optional,
  hilfe,
  fehler,
  hinweissatz,
  feldhilfe,
  layout,
  groesse = "standard",
  rows = 3,
  ...rest
}: FeldEigenschaften & MehrzeilerRest) {
  return (
    <Feld id={id} label={label} labelVersteckt={labelVersteckt} optional={optional} hilfe={hilfe} fehler={fehler} hinweissatz={hinweissatz} feldhilfe={feldhilfe} beispielInMehrzeiler layout={layout} groesse={groesse}>
      {(a) => (
        <FeldHuelle>
          {/* Preline: component/textarea/textarea-label */}
          <textarea
            {...rest}
            id={a.id}
            rows={rows}
            className={a.fehlerhaft ? KLASSEN[grundGroesse(groesse)].fehler : KLASSEN[grundGroesse(groesse)].normal}
            aria-describedby={a["aria-describedby"]}
            aria-invalid={a["aria-invalid"]}
          />
        </FeldHuelle>
      )}
    </Feld>
  );
}
